module.exports = __webpack_public_path__ + "img/cloth_g3_shoe-07.949e978a.svg";